/**
 * Fires a best-effort "this subpage was opened" ping once per mount — feeds
 * the Admin "Usage" tab (server side: analytics-service/hubUsage.js,
 * dashboard: 'hubPageView'). Wrapped around each entry's `element` in
 * registry.tsx, so adding a dashboard here is automatic — no per-page work
 * needed elsewhere. Never blocks rendering or surfaces anything to the user;
 * a failed ping is silently dropped, same as any other telemetry side effect.
 */
import { useEffect, type ReactNode } from 'react';

export function PageViewPing({ pageKey, children }: { pageKey: string; children: ReactNode }) {
  useEffect(() => {
    // Dynamic import: this file is reached from the always-loaded registry, and a
    // static import of AnalyticsPages would drag it + Recharts into the main bundle.
    import('./AnalyticsPages')
      .then(({ callAny }) => callAny({ dashboard: 'hubPageView', page: pageKey }))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageKey]);
  return <>{children}</>;
}
